import { concat } from "ramda";

export const successType = (action) => concat(action, "_SUCCESS");

export const failureType = (action) => concat(action, "_FAILURE");

export const requestType = (action) => concat(action, "_REQUEST");
